import PaymentGatewayProcessor from './paymentGatewayProcessorAbstract';

export default class PaymentwallGateway extends PaymentGatewayProcessor {}
